import { useCallback } from 'react';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'js/store/hooks';

import * as Types from '../types';
import { useGetGameConfig } from './useGetGameConfig';
import { useGetUrlTypeList } from './useGetUrlTypeList';

export const useGetWrapperLaunchUrl = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const preview = searchParams.get('preview') || '';
    const themeName = useAppSelector(prop('themeName'));
    const getGameConfig = useGetGameConfig();
    const getUrlTypeList = useGetUrlTypeList();
    const requestStamp = useAppSelector(prop('requestStamp'));

    return useCallback(({ gameCode, mode, additionalQueryString }: Types.IGetLaunchURLParams): string => {
        const urlTypeList = getUrlTypeList({ gameCode, mode });
        const wrapperUrl = new URL(`${window.location.origin}/${themeName}/js/app-out/html/wrapper.html`);
        const {
            name = '',
            mobileGameCode = '',
            gameType = '',
            integrationType = '',
            liveLaunchAlias = '',
            urlCustomParameters = ''
        } = getGameConfig(gameCode) || {};

        wrapperUrl.searchParams.append('urlType', urlTypeList[0]);
        wrapperUrl.searchParams.append('preview', preview);
        wrapperUrl.searchParams.append('t', `${requestStamp}`);
        wrapperUrl.searchParams.append('gameName', name);
        wrapperUrl.searchParams.append('gameType', gameType);
        wrapperUrl.searchParams.append('game', gameCode);
        wrapperUrl.searchParams.append('gameCode', gameCode);
        wrapperUrl.searchParams.append('mobileGameCode', mobileGameCode || gameCode);
        wrapperUrl.searchParams.append('integrationType', integrationType);
        wrapperUrl.searchParams.append('liveLaunchAlias', liveLaunchAlias);
        wrapperUrl.searchParams.append('urlCustomParameters', urlCustomParameters);
        wrapperUrl.searchParams.append('additionalQueryString', additionalQueryString || '');

        return wrapperUrl.toString();
    }, [
        themeName,
        preview,
        requestStamp,
        getGameConfig,
        getUrlTypeList
    ]);
};
